import { actionTypes } from "../utils";

export const types = {
  ...actionTypes('SET_LAWS'),
  ...actionTypes('CREATE_LAW'),
  ...actionTypes('CHECK_LAW'),
  ...actionTypes('DELETE_LAW'), 
  ...actionTypes('UPDATE_LAW'),
};